import { render, staticRenderFns } from "./Segment.vue?vue&type=template&id=d88e24c4&scoped=true"
import script from "./Segment.vue?vue&type=script&lang=js"
export * from "./Segment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88e24c4",
  null
  
)

export default component.exports